import React, { useState } from 'react';
import { criarRegraEspecial, deletarRegraEspecial } from '../../services/api';
import './RegrasEspeciaisSection.css';

function RegrasEspeciaisSection({
  pecaId,
  regrasEspeciais = [],
  selectedFuros,
  furosVerticais = [],
  onRegrasAtualizadas,
  onHoverRegra,
}) {
  const [collapsed, setCollapsed] = useState(false);
  const [erroInline, setErroInline] = useState('');
  const [loadingCriar, setLoadingCriar] = useState(false);

  const getLabelFuro = (uid) => {
    const idx = furosVerticais.findIndex((f) => f.uid === uid);
    return idx >= 0 ? `V${idx + 1}` : uid.slice(0, 6);
  };

  const handleCriar = async () => {
    if (!pecaId || selectedFuros.size === 0) return;
    setErroInline('');
    setLoadingCriar(true);
    try {
      const novaRegra = await criarRegraEspecial(pecaId, {
        tipo: 'deslocamento_cabecote',
        uids_furos: Array.from(selectedFuros),
      });
      onRegrasAtualizadas([...regrasEspeciais, novaRegra]);
    } catch (err) {
      const msg = err.response?.data?.detail || 'Erro ao criar regra.';
      setErroInline(msg);
    } finally {
      setLoadingCriar(false);
    }
  };

  const handleDeletar = async (regraId) => {
    if (!pecaId) return;
    setErroInline('');
    try {
      await deletarRegraEspecial(pecaId, regraId);
      onRegrasAtualizadas(regrasEspeciais.filter((r) => r.id !== regraId));
    } catch (err) {
      const msg = err.response?.data?.detail || 'Erro ao remover regra.';
      setErroInline(msg);
    }
  };

  const podeCriar = pecaId && selectedFuros.size > 0;

  return (
    <div className="regras-section">
      <div className="regras-section-header" onClick={() => setCollapsed((c) => !c)}>
        <span className="regras-section-icon"></span>
        <span>Regras Especiais</span>
        <span className="regras-section-count">{regrasEspeciais.length}</span>
        <span className={`regras-chevron ${collapsed ? 'collapsed' : ''}`}>›</span>
      </div>

      {!collapsed && (
        <div className="regras-section-body">
          {regrasEspeciais.length === 0 ? (
            <p className="regras-empty">Nenhuma regra cadastrada.</p>
          ) : (
            <ul className="regras-list">
              {regrasEspeciais.map((regra, i) => (
                <li
                  key={regra.id}
                  className="regra-item"
                  onMouseEnter={() => onHoverRegra(regra)}
                  onMouseLeave={() => onHoverRegra(null)}
                >
                  <span className="regra-label">
                    Regra {i + 1}:{' '}
                    <span className="regra-furos">
                      {regra.uids_furos.map(getLabelFuro).join(', ')}
                    </span>
                    <span className="regra-tipo"> (des. cabeçote)</span>
                  </span>
                  <button
                    className="regra-remover"
                    onClick={() => handleDeletar(regra.id)}
                    title="Remover regra"
                  >
                    ×
                  </button>
                </li>
              ))}
            </ul>
          )}

          <button
            className="regras-nova-btn"
            onClick={handleCriar}
            disabled={!podeCriar || loadingCriar}
            title={!podeCriar ? 'Selecione 1 ou mais furos verticais' : 'Criar regra com os furos selecionados'}
          >
            {loadingCriar ? '...' : '+ Nova regra'}
          </button>

          {erroInline && (
            <p className="regras-erro">{erroInline}</p>
          )}
        </div>
      )}
    </div>
  );
}

export default RegrasEspeciaisSection;
